export default __webpack_public_path__ + "static/media/policy-analysis.f927d5ba.png";